/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { isTruthy } from '@app/common/utils';
import { licenseStatus, targetSelector } from '@app/core/ngrx';
import { AppState } from '@app/core/types';
import { Store } from '@ngrx/store';
import { GGCCLicenseType } from '@shared/types/license';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PageNoLicenseGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(targetSelector).pipe(
      filter(isTruthy),
      switchMap((target) => {
        if (target === 'hosted') return of(this.router.parseUrl(''));

        return this.store.select(licenseStatus).pipe(
          filter(Boolean),
          take(1),
          map((val) => val.licenseType === GGCCLicenseType.noLicense || this.router.parseUrl('')),
        );
      }),
    );
  }
}
